export default __webpack_public_path__ + "static/media/gallery_07.02329828.jpg";